/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';

export function useAutoRefresh(fetcher, interval = 20000, enabled = true) {
  const fetcherRef = useRef(fetcher);
  fetcherRef.current = fetcher;

  useEffect(() => {
    if (!enabled) return undefined;

    let timer = null;
    let cancelled = false;

    const safeFetch = async () => {
      if (cancelled) return;
      try {
        await fetcherRef.current?.();
      } catch (err) {
        console.warn('[useAutoRefresh] fetch failed:', err?.message || err);
      }
    };

    const start = () => {
      stop();
      if (document.visibilityState === 'visible') {
        timer = setInterval(safeFetch, interval);
      }
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        safeFetch();
        start();
      } else {
        stop();
      }
    };

    const onFocus = () => {
      if (document.visibilityState === 'visible') safeFetch();
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('focus', onFocus);
    start();

    return () => {
      cancelled = true;
      stop();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('focus', onFocus);
    };
  }, [interval, enabled]);
}
